export default "__VITE_ASSET__ZdaqhBDD__"